import Bills from '.';
import { IRoute } from '../../utils/navigation/routes';
import BillDetail from './billDetail';
import BillsDownload from './billsDownload';
import BillsDownloadFeedback from './billsDownload/billsDownloadFeedback';
import ModalDebtPayment from './modalDebtPayment';
import GcoFlow from './modalDebtPayment/gcoFlow';
import FeedbackGco from './modalDebtPayment/gcoFlow/feedback-gco';
import ModalRehabilitationLines from './modalDebtPayment/modalRehabilitationLines';
import RehabilitationLinesFeedback from './modalDebtPayment/modalRehabilitationLines/RehabilitationLinesFeedback';

export const billsRoutes: IRoute[] = [
    { path: '/bills', element: <Bills /> },
    { path: '/bills/bill-detail', element: <BillDetail /> },
    { path: '/bills/gco-flow', element: <GcoFlow /> },
    { path: '/bills/gco-flow/feedback', element: <FeedbackGco /> },
    { path: '/modal-debt-payment', element: <ModalDebtPayment /> },
    { path: '/modal-debt-payment/modal-rehabilitation-lines', element: <ModalRehabilitationLines /> },
    { path: '/modal-rehabilitation-lines/rehabilitation-lines-feedback', element: <RehabilitationLinesFeedback /> },
    { path: '/bills-download', element: <BillsDownload /> },
    { path: '/bills-download/feedback', element: <BillsDownloadFeedback /> },
];
